

import React, { useEffect, useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { motion, AnimatePresence } from "framer-motion";

interface TransitionProps {
  duration?: number; // en ms
}

const Transition: React.FC<TransitionProps> = ({ duration = 2000 }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed top-0 left-0 w-full h-full z-[9999] bg-white flex items-center justify-center"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <DotLottieReact
            src="https://lottie.host/fbef58b1-16fa-447b-ac24-c04a2cad76e8/L6ffxZ1GQG.lottie"
            loop
            autoplay
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Transition;
